<div *ngIf="timeZone" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="center center">
    <div [ngClass]="{'hide-filter': !useFilter}"
         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <app-time-filter [profile]="TimeFilterProfile.EC_ECONOMICS"
                         [allowedTypes]="allowedTypes"
                         [disabledTypes]="disabledTypes"
                         [setType]="setType"
                         [isKeepPreviousSelectionEnabled]="true"
                         (timeFilterChange)="onSelectTimeFilter($event)">
        </app-time-filter>
    </div>
    <mat-form-field *ngIf="timeMode === Mode.SINGLE">
        <input matInput [matDatepicker]="picker"
               [min]="minStartDate"
               [max]="futureDate"
               [formControl]="singleDate">
        <mat-error *ngIf="!singleDate.valid">
            {{'Select another month'|i18n}}
        </mat-error>
        <mat-datepicker-toggle matSuffix [for]="picker">
            <app-icon matDatepickerToggleIcon name="fal-calendar"></app-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker
                        startView="multi-year"
                        (monthSelected)="onSetDate($event, 'single'); picker.close()"
                        panelClass="month-picker">
        </mat-datepicker>
    </mat-form-field>
    <ng-container *ngIf="timeMode === Mode.RANGE">
        <mat-form-field>
            <input matInput [matDatepicker]="startPicker"
                   [min]="minStartDate"
                   [max]="maxStartDate"
                   [formControl]="startDate"
                   [readonly]="true">
            <mat-error *ngIf="startDate.hasError('crossYear')">
                {{'Select months in the same year'|i18n}}
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker
                            startView="multi-year"
                            (monthSelected)="onSetDate($event, 'start'); startPicker.close()">
            </mat-datepicker>
        </mat-form-field>
        <div>&#8212;</div>
        <mat-form-field>
            <input matInput [matDatepicker]="endPicker"
                   [min]="minEndDate"
                   [max]="maxEndDate"
                   [formControl]="endDate"
                   [readonly]="true">
            <mat-error *ngIf="endDate.hasError('crossYear')">
                {{'Select months in the same year'|i18n}}
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker
                            startView="multi-year"
                            (closed)="closePicker()"
                            (monthSelected)="onSetDate($event, 'end'); endPicker.close()">
            </mat-datepicker>
        </mat-form-field>
    </ng-container>
</div>
